import { cn } from '@/lib/utils';
import React from 'react';

interface StepIndicatorProps {
    steps: string[];
    currentStep: number;
    completedSteps: number[];
}

export const StepIndicator: React.FC<StepIndicatorProps> = ({
    steps,
    currentStep,
    completedSteps,
}) => {
    const getBorderColor = (index: number) => {
        if (completedSteps.includes(index)) {
            return 'border-green-500'; // or whatever color you want for completed steps
        } else if (currentStep === index) {
            return 'border-blue-500'; // or whatever color you want for current step
        } else {
            return 'border-gray-300'; // or whatever color you want for inactive steps
        }
    };

    return (
        <div className="flex flex-col justify-between gap-y-16 h-full mx-4">
            {steps.map((step, index) => (
                <div key={step} className="flex items-center relative">
                    <div className="flex gap-5 items-center">
                        <div className="relative">
                            {completedSteps.includes(index) ? (
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_10549_131201)">
                                        <circle cx="12" cy="12" r="11.25" fill="#00A82D" stroke="#00A82D" stroke-width="1.5" />
                                    </g>
                                    <path d="M9.43369 14.7315L16.6652 7.5L17.6254 8.46019L9.43369 16.6519L5.625 12.8443L6.58519 11.8841L9.43369 14.7315Z" fill="#F9F9F9" />
                                    <defs>
                                        <clipPath id="clip0_10549_131201">
                                            <rect width="24" height="24" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            ) : (
                                currentStep === index ? 
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clipPath="url(#clip0_10549_131211)">
                                        <circle cx="12" cy="12" r="11.25" fill="white" stroke="#0162DD" strokeWidth="1.5" />
                                        <circle cx="12" cy="12" r="4.125" fill="#0162DD" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_10549_131211">
                                            <rect width="24" height="24" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                                :
                                <div className="rounded-full w-6 h-6 border flex items-center justify-center border-gray-400">
                                    {index + 1}
                                </div>
                            )}
                            
                            {/* Dotted border line - only show if not the last step */}
                            {index < steps.length - 1 && (
                                <div 
                                    className={cn(
                                        "absolute left-1/2 transform -translate-x-1/2 border-l-2 border-dotted",
                                        getBorderColor(index)
                                    )}
                                    style={{
                                        top: '100%',
                                        height: '4rem', // Adjust this to match your gap-y-16 spacing
                                    }}
                                />
                            )}
                        </div>
                        <span className={`text-xs whitespace-nowrap text-center ${currentStep === index ? 'text-blue-700' : 'text-gray-600'}  w-full`}>
                            {step}
                        </span>
                    </div>
                </div>
            ))}
        </div>
    );
};